import type { HelpFile } from '../../types/help'
import { IdentityManagementTestIds } from '../../../testids/IdentityManagementTestIds'

export const identityManagementHelp: HelpFile = {
  docPage: '/docs/identity/overview',
  texts: {
    [IdentityManagementTestIds.identityManagementWelcomeCard]:
      'Identity Management landing page — pick a tool from the sidebar: parties, identities, accounts, and onboarding.',
  },
}
